export default {
  setCurrency: (code) => {
    window.app.bus.$emit('currency/set', code)
  },
}
